import React from 'react';
import {
  Container, Row, Col, Tab, Nav,
} from 'react-bootstrap';
import TrackVisibility from 'react-on-screen';
import { useTranslation } from 'react-i18next';
import { ProjectCard } from './ProjectCard';
import projImg1 from '../assets/img/airbnb.jpg';
import projImg2 from '../assets/img/amazon.jpg';
import projImg3 from '../assets/img/finance.jpg';
import projImg4 from '../assets/img/spotify.jpg';
import projImg5 from '../assets/img/farmacia.jpg';
import projImg6 from '../assets/img/medical.jpg';
import 'animate.css';

export const Projects = () => {
  const [t] = useTranslation('global');
  const projects = [
    {
      title: 'Full Stack  Airbnb',
      description: t('individuals.project'),
      seeSource: t('individuals.seeSource'),
      technologies1: 'React',
      technologies0: 'NextJS',
      technologies2: 'Typescript',
      technologies3: 'Mongo.db',
      technologies4: 'Express',
      link1: 'https://github.com/maximoortelli/Full-Stack-Airbnb',
      seeLive: t('individuals.seeLive'),
      link2: 'https://full-stack-rental-maximo-rueda.vercel.app/',

      imgUrl: projImg1,
    },
    {
      title: 'Full Stack Spotify',
      description: t('individuals.project5'),
      seeSource: t('individuals.seeSource'),
      technologies0: 'Typescript',
      technologies1: 'Javascript',
      technologies2: 'React',
      technologies3: 'Next.js',
      technologies4: 'PostgreSQL',
      link1: 'https://github.com/maximoortelli/Full-Stack-Spotify',
      seeLive: t('individuals.seeLive'),
      link2: 'https://full-stack-spotify-maximo-rueda-proyect.vercel.app/',
      imgUrl: projImg4,
    },
    {
      title: 'Full Stack Amazon',
      description: t('individuals.project2'),
      seeSource: t('individuals.seeSource'),
      technologies0: 'JavaScript',
      technologies1: 'React',
      technologies2: 'Redux',
      technologies3: 'Firebase',
      technologies4: 'Tailwind.CSS',
      link1: 'https://github.com/maximoortelli/Full-Stack-Amazon',
      seeLive: t('individuals.seeLive'),
      link2: 'https://full-stack-amazon-maximo-rueda-proyect.vercel.app/',
      imgUrl: projImg2,
    },
    {
      title: 'Full Stack Farmacia',
      description: t('individuals.project6'),
      technologies0: 'Javascript',
      technologies1: 'Node.js',
      technologies2: 'React',
      technologies3: 'Mongo.db',
      technologies4: 'Express',
      seeLive: t('individuals.seeLive'),
      link2: 'https://farmaciapizzolo.com.ar/',
      imgUrl: projImg5,
    },
    {
      title: 'Full Stack Medical',
      description: t('individuals.project3'),
      seeSource: t('individuals.seeSource'),
      technologies1: 'Javascript',
      technologies0: 'React',
      technologies2: 'Node',
      technologies3: 'Mongo.db',
      technologies4: 'Express',
      link1: 'https://github.com/maximoortelli/Full-Stack-Medical-App',
      seeLive: t('individuals.seeLive'),
      link2: 'https://front-end-medical-app-maximo-rueda.vercel.app/',
      imgUrl: projImg6,
    },
    {
      title: 'Finance App',
      description: t('individuals.project4'),
      seeSource: t('individuals.seeSource'),
      technologies0: 'Javascript',
      technologies1: 'React',
      technologies2: 'Redux',
      technologies3: 'NodeJS',
      technologies4: 'SASS',
      link1: 'https://github.com/maximoortelli/Finance-App',
      seeLive: t('individuals.seeLive'),
      link2: 'https://finance-app-maximo-rueda.vercel.app/',
      imgUrl: projImg3,
    },
    // Agrega más proyectos según sea necesario
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? 'animate__animated animate__fadeIn' : ''}>
                  <h2>{t('projects.projects')}</h2>
                  <div className="prodesc">
                    <p className="text-white">{t('projects.description')}</p>
                  </div>

                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first" className="aca">{t('projects.projects')}</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? 'animate__animated animate__slideInUp' : ''}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => (
                            <ProjectCard
                              key={index}
                              {...project}
                            />
                          ))}
                        </Row>
                      </Tab.Pane>
                      {/* Agrega más pestañas según sea necesario */}
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
